export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5585.1374d5bb.jpg";